const supportedPensionProviders = [
  {
    name: "PeoplesPension",
    displayName: "The People's Pension",
    delegationDescription: "Add delegate access to info@thepayrolldepartment.co.uk with full access to manage enrolments and contributions"
  },
  {
    name: "NEST",
    displayName: "NEST",
    delegationDescription: "Add delegate access to info@thepayrolldepartment.co.uk with full access to manage enrolments and contributions"
  },
  {
    name: "SMART",
    displayName: "SMART Pension",
    delegationDescription: "Add delegate access to info@thepayrolldepartment.co.uk with full access to manage enrolments and contributions"
  }
];

export default supportedPensionProviders;